import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../constants/dataAids';
import imageCropOptions from '../../constants/imageCropOptions';

class ServiceListItemAsset extends React.Component {
  render() {
    const { assetUrl, assetStyles, imageCropMethod } = this.props;
    const {
      Element: { Block },
      Component: { Background }
    } = UX2;
    const styles = {
      outer: {
        position: 'relative',
        paddingTop: '75%',
        paddingRight: '100%',
        ...assetStyles
      },
      inner: {
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundSize: imageCropMethod === imageCropOptions.EXPAND_TO_FILL ? 'cover' : 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    };

    return (
      <Block style={ styles.outer } data-aid={ dataAids.SERVICE_LIST_ITEM_ASSET }>
        <Background backgroundImage={ assetUrl } style={ styles.inner } />
      </Block>
    );
  }
}

ServiceListItemAsset.propTypes = {
  assetUrl: PropTypes.string,
  assetStyles: PropTypes.obj,
  imageCropMethod: PropTypes.string
};

export default ServiceListItemAsset;
